import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
//import firebase from 'firebase';
import { AngularFirestore } from 'angularfire2/firestore';
import { CreateBrokerPage } from '../create-broker/create-broker';
import { LoadingProvider } from '../../providers/loading/loading';
import { ViewBrokerPage } from '../view-broker/view-broker';
import { Http, RequestOptions, Headers } from '@angular/http';
import {EnvDataService} from '../../app/services/env-data-service';
@Component({
  selector: 'page-brokers',
  templateUrl: 'brokers.html',
  providers:[EnvDataService]
})
export class BrokersPage {

  public email: any;
  public uid: any;
  public firstname: any;
  public lastname: any;
  public getRole: any;
  public usersList : any = [];
  data: any;
  public deleted_access: any;

  constructor(
    public navCtrl: NavController, 
    public db: AngularFirestore,
    public navParams: NavParams,
    public loadingProvider: LoadingProvider,
    public http: Http,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private EnvDataService:EnvDataService
  ) {

    this.email = window.localStorage.getItem("email");
    this.uid = window.localStorage.getItem("uid");
    this.deleted_access = window.localStorage.getItem("deleted_access");

    this.getAllBrokers().subscribe((data)=>{
      this.data = data;
    }); 
    let random_id = this.stringGen(10);
    window.localStorage.setItem("random_id", random_id);
  }

  getAllBrokers (){
    if(this.deleted_access > 0){
      return this.db.collection<any>( "users" , ref => ref.where('roles.broker','==',true )).valueChanges ();
    }else{
      return this.db.collection<any>( "users" , ref => ref.where('roles.broker','==',true ).where('deleted','<',1 )).valueChanges ();
    }
  }

  addBroker(event){
    this.navCtrl.push(CreateBrokerPage);
  }

  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }

  ionViewDidLoad() {
  }

  viewBroker(event, contact_uid){
    this.navCtrl.push(ViewBrokerPage,{
      contact_uid:contact_uid
      });
  }

  editBroker(event, contact_uid){
    this.navCtrl.push(CreateBrokerPage,{
      edit_contact_uid:contact_uid
      });
  }

  deleteBroker(event, contact_uid){
    let alert = this.alertCtrl.create({
      title: 'Confirm delete Broker',
      message: 'Are you sure you want to delete this Broker?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'contact_uid' : contact_uid,
                    'deleted_date' : new Date().getTime()
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/deleteBroker";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Deleted successfully.');
                      this.loadingProvider.stopLoading();
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }
              }
          }
      ]
    });
    alert.present();
  }


  restoreBroker(index: number, contact_uid: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm restore Broker',
      message: 'Are you sure you want to restore this Broker?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'contact_uid' : contact_uid
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/restoreBroker";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Restore successfully.');
                      this.loadingProvider.stopLoading();
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }                
              }
          }
      ]
    });
    alert.present();
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/brokers/brokers.ts